import React from 'react';
import classNames from 'classnames';
import './Cell.less';

interface ICellProps extends React.HTMLProps<HTMLDivElement> {}

const getClassName = (className?: string) => classNames(className, 'tt-cell');

/**
 * Truth table cell. It is used for aligning content inside cell.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function Cell({ className, ...otherProps }: ICellProps) {
  return <div className={getClassName(className)} {...otherProps}></div>;
}
